import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { environment } from '../../../../environments/environment';
import { SeoService } from '../../../core/services/seo/seo.service';
import { Router } from '@angular/router';
import { AppService } from '../../../shared/app.service';
import { DigitOnlyDirective } from '../../../shared/digit-only.directive'
import { FormsModule, FormGroup, FormBuilder, Validators, FormControl, 
  ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA,MatDialog } from "@angular/material/dialog";
import { AlertsModalComponent } from '../../../shared/components/alerts/alertsModal.component';
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    DigitOnlyDirective,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

  envName = environment.application.name;
  angular = environment.application.angular;
  bootstrap = environment.application.bootstrap;
  fontawesome = environment.application.fontawesome;

  submitted: Boolean = false;
  loading:Boolean = false;

  userForm!: FormGroup;
  imei: FormControl;
  name: FormControl;
  mobile: FormControl;
  email: FormControl;
  consent: FormControl;

  constructor(
    private seoService: SeoService, 
    private router: Router,
    private service: AppService,
    private fb: FormBuilder,
    public dialog: MatDialog
  ) {

    const content = 'Erajaya Redemption Portal ';
    const title = 'Erajaya Redemption';

    this.seoService.setMetaDescription(content);
    this.seoService.setMetaTitle(title);

    this.imei = new FormControl('', [
        Validators.required,
        Validators.minLength(15)
      ]
    );
    this.name = new FormControl('', [
        Validators.required
      ]
    );
    this.mobile = new FormControl('', [
        Validators.required,
        Validators.minLength(10)
      ]
    );
    this.email = new FormControl('', [
        Validators.required,
        Validators.email
      ]
    );
    this.consent = new FormControl('', [
        Validators.required,
      ]
    );
  }
  
  ngOnInit(): void {
    this.userForm = this.fb.group({
      email: this.email,
      imei: this.imei,
      name: this.name,
      mobile: this.mobile,
      consent: this.consent,
    });
  }

  onSubmit() {
    var data = "";
    this.submitted = true;
    console.log("Is Form Valid:",this.userForm.valid);
    if (this.userForm.invalid) {
      return;
    }

    this.loading=true;

    let redeemPayload = {
      email:this.f['email']['value'],
      imei:this.f['imei']['value'],
      name:this.f['name']['value'],
      dateOfBirth:"", //don't have such field in form
      mobile:this.f['mobile']['value'],
      identityNumber:"" //don't have such field in form
    };

    this.service.auth().subscribe(res=>{
      this.loading = false;
      let token = res.access_token;

      this.service.redeem(token,redeemPayload).subscribe(res=>{
        this.router.navigate(['/erajaya/confirmation']);
      },(err) => {
        this.submitted = false;
        this.loading = false;
        if (err.status==400){ //validation failure
          let validationFailureObj = err.error.error.details;
          const msg = Object.values(validationFailureObj);
          data = msg.toString();
        } else if(err.status==403) {
          //data = err.error.error.message;
          data = "Kami tidak menemukan IMEI yang Anda berikan, mohon daftarkan IMEI yang benar";
        }else {
          data = "Ups! Terjadi kesalahan. Silakan coba kembali beberapa saat lagi.";
        }
        const dialogRef = this.dialog.open(AlertsModalComponent, {
          width: '50%',
          height: '75%',
          panelClass: 'duplicate-dialog-class',
          position: {
            top: '35vh'      
          },
          data: [data]
        });
      })
    },(err) => {
      this.loading = false;
      const dialogRef = this.dialog.open(AlertsModalComponent, {
        width: '50%',
        height: '75%',
        panelClass: 'duplicate-dialog-class',
        position: {
          top: '35vh'      
        },
        data: ["Ups! Terjadi kesalahan. Silakan coba kembali beberapa saat lagi."]
      });
    });
  }

  get f() { 
    return this.userForm.controls; 
  }
}
